import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { useIsIOS } from '../../hooks/useDeviceDetection';
import { useOrganizationSelector } from '../../hooks/useOrganizationSelector';
import usePylonChat from '../../hooks/usePylonChat';
import { getNotificationsList } from '../../redux/actions/notificationActions';
import { getOrganizations } from '../../redux/actions/organizationActions';
import { getUserDetails } from '../../redux/actions/userActions';
import { selectCurrentUser } from '../../selectors/authSelectors';
import NavigationBar from '../NavigationBar/NavigationBar';

import styles from './DashboardBase.module.scss';

const useInitializeUser = () => {
  const dispatch = useDispatch();
  const userId = useSelector((state) => state.authReducer.currentUser.user?.id);

  useEffect(() => {
    if (userId) dispatch(getUserDetails(userId));
  }, [userId, dispatch]);
};

const useFetchCoreLists = () => {
  const dispatch = useDispatch();
  const currentUser = useSelector(selectCurrentUser);

  useEffect(() => {
    if (currentUser) {
      dispatch(getNotificationsList({ offset: 0 }));
      dispatch(getOrganizations());
    }
  }, [currentUser, dispatch]);
};

const DashboardBase = ({ children }) => {
  useInitializeUser();
  useFetchCoreLists();
  useOrganizationSelector();
  usePylonChat();

  const location = useLocation();
  const isJobsRoute = location.pathname.includes('/jobs');
  const isIOSDevice = useIsIOS();

  return (
    <div className={styles.dashboardBase}>
      <NavigationBar isIOSDevice={isIOSDevice} />
      <div className={isJobsRoute ? styles.jobsDashboardContent : styles.dashboardContent}>{children}</div>
    </div>
  );
};

export default DashboardBase;
